<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <div slot="title" class="flex">
            <ht-staff-area-select v-if="staffLoggedIn" class="w-1/2"></ht-staff-area-select>
            <ht-company-select v-if="companyLoggedIn" class="w-1/2"></ht-company-select>
        </div>

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <a href="#" @click="refreshCompanies">Refresh Companies</a>

        <vs-spacer />

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
import ProfileDropDown  from './components/ProfileDropDown.vue'
import StaffAreaSelect from './components/StaffAreaSelect.vue'
import CompanySelect from './components/CompanySelect.vue'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    ProfileDropDown,
    'ht-staff-area-select': StaffAreaSelect,
    'ht-company-select': CompanySelect
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    staffLoggedIn () {
      return localStorage.getItem('stafftoken') !== null;
    },
    companyLoggedIn () {
      return localStorage.getItem('companytoken') !== null;
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },

    refreshCompanies() {
      this.$http
          .get("https://staffapi.staging.hebtrek.nl/v1/delivery/companies/cached-list", {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then(() => {
            this.$util.notify("Gelukt!", "Company cache is successvol geupdate.", this.$vs);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    }
  }
}
</script>
